export default __webpack_public_path__ + "static/media/co3.7208aebb.png";